import { render, staticRenderFns } from "./DeviceAssignment.vue?vue&type=template&id=3941742b&scoped=true"
import script from "./DeviceAssignment.vue?vue&type=script&lang=js"
export * from "./DeviceAssignment.vue?vue&type=script&lang=js"
import style0 from "./DeviceAssignment.vue?vue&type=style&index=0&id=3941742b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941742b",
  null
  
)

export default component.exports